export const CheckPermissions = (userInfo, permission) => {

    

    if (localStorage.getItem('subUserInfo')) {
        if (JSON.parse(localStorage.getItem('subUserInfo')).is_master == 1)
            return true

            console.log("permissionpermission",  JSON.parse(localStorage.getItem('subUserInfo')).Permissions, permission)

        if (JSON.parse(localStorage.getItem('subUserInfo')).Permissions && JSON.parse(localStorage.getItem('subUserInfo')).Permissions.includes(permission))
            return true
        else
            return false
    }

    return false
    // console.log('userInfo.Post',userInfo)
    // if (userInfo.Post == "مدیر")
    //     return true

    // if (userInfo.Permissions && userInfo.Permissions.includes(permission))
    //     return true
    // else
    //     return false

}